import React from 'react';
import { Link } from 'react-router-dom';
import ReactDOM from 'react-dom';
import styles from './CandidateProfile.module.scss';
import Dashboard from '../../components/Dashboard';
import CandidateVideo from '../../components/CandidateVideo/candidateVideo';
import ReactTooltip from 'react-tooltip';
import UserContext from '../../User/User';
import firebase from 'firebase';
import add_acc_logo from '../../assets/manage account/noprofilepic.jpg';
import javaIcon from '../../assets/icons/progressBar/javaIcon.png';
import react from '../../assets/icons/progressBar/react.png';
import Candidate from '../../components/Candidate';
import response from '../../assets/icons/progressBar/cyber incident response.png';
import compliance from '../../assets/icons/progressBar/Governance risk compliance.png';
import infrastructure from '../../assets/icons/progressBar/infrastructure design.png';
import secure from '../../assets/icons/progressBar/secure implementation.png';
import threat from '../../assets/icons/progressBar/Threat & Attack Vectors.png';
import { ContactSupportOutlined } from '@material-ui/icons';

class Candidate_Profile extends React.Component {
	constructor() {
		super();
		this.state = {
			checked: true,
			id: '',
			name: '',
			source: '',
			title: '',
			remote: '0%',
			presentation: '0%',
			java: '0%',
			react: '0%',
			vue: '0%',
			angular: '0%',
			education: [],
			rngSkills:[],
			experiences: [],
			mentors: [],
			technicalSkills: [],
			languageSkills: [],
			arrowDirection: 'collapse_arrow_left',
			dashCollapse: 'left',
			favoriteClass: 'gray',
			tooltip: 'tooltiphidden',
			tooltiptext: 'Save Profile',
			index: 0,
			show: false,
			videoExists: false,
			url: '',
			grades:[],
			mentorUrl:[],
			showVideo: false,
			showPresentation:true,
			moodleCandidates:[],
			skills: []
		};

		this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
		this.handleFavoriteEnter = this.handleFavoriteEnter.bind(this);
		this.handleFavoriteLeave = this.handleFavoriteLeave.bind(this);

		this.handleScroll = this.handleScroll.bind(this);
		this.displayExperiences = this.displayExperiences.bind(this);
		this.displayEducation = this.displayEducation.bind(this);
		this.displayTechnical = this.displayTechnical.bind(this);
		this.displayLanguages = this.displayLanguages.bind(this);
		this.displayMentors = this.displayMentors.bind(this);
		this.displayGrades = this.displayGrades.bind(this);
		this.handleDisplayVideo = this.handleDisplayVideo.bind(this);
		this.handleDataLoad = this.handleDataLoad.bind(this);
		this.UrlExists = this.UrlExists.bind(this)
	}
	static contextType = UserContext;

	displayGrades() {
		let old=false;
		const db = firebase.firestore();
		db.collection('ALL_USER')
		.where('candidateID', '==', this.state.id)
		.get()
		.then((querySnapshot) => {
		  const data = querySnapshot.docs.map((doc) => doc.data());
		  if(data.length>0){
	
			if(data[0].old===true){
				old=true;
			}
		  }

	
		 });
		const { grades } = this.state;
		var gradesList = [];
		var i;
		if(grades==undefined){
			return gradesList;
		}
		let cats = [];
		let pics = [];
		let sizing = [];
		if(grades.length==6){
			cats=["Threats & Attack Vectors", "Infrastructure Design", "Secure Implementation", "Cyber Incident Response", "Governance, Risk & Compliance"];
			sizing=["gradeIconCyber","gradeIconCyber","gradeIconCyber","gradeIconCyber","gradeIconCyber"]
			pics=[response,compliance,infrastructure,secure,threat];

		}else{
			cats=["React","Java"];
			sizing=["gradeIconReact","gradeIconJava"]
			pics=[react,javaIcon];
		}


		try {
			for (i = 1; i < grades.length; i++) {
				
				gradesList.push(
					<div className={styles.grade}>
					<div className={styles.ProgressBar}>
						<div class={`c100 p${grades[i]} medium center yellow`}>
							<span><img className={styles[sizing[i-1]]} src= {pics[i-1]}/></span>
							<div class="slice">
								<div class="bar"></div>
								<div class="fill"></div>
							</div>
						</div>
					</div>
					<div className={styles.gradeInfo}>
						<h5>{cats[i-1]}</h5>
						<p>{grades[i]}% </p>
					</div>
				</div>
				);
			}
			return gradesList;
		} catch (err) {
			console.log("Error: database fields don't match");
		}
	}

	displayExperiences() {
		var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
		const { experiences } = this.state;
		var experienceList = [];
		var i;
		try {
			for (i = 0; i < experiences.length; i++) {
				let company;
				let end;
				let start;
				let title;
				let index = i;
				let bullets = [];
				var accomplishmentList = [];
				let accomplishments;
				try {
					company = experiences[i].company;
					title = experiences[i].title;
					end = experiences[i].end;
					start = experiences[i].start;

					accomplishments = experiences[i].accomplishments;
					if(accomplishments == undefined){
						console.log("undefined")
						bullets.push(<h4>- No accomplishments</h4>)
					}
					else if(accomplishments.split("*")){
						var res = accomplishments.split("*");  
						var x;
						for(x =0;x<res.length;x++){
							bullets.push(<li>{res[x]}</li>)
						}
					}
					else if(accomplishments.split(" ● ")){
							var res = accomplishments.split(" ● "); 
							var x;
						for(x =1;x<res.length;x++){
							bullets.push(<li>{res[x]}</li>)
						}
					}
				}catch (err) {
					continue;
				}
				let start_date = new Date(start.seconds*1000)
				let end_date = new Date(end.seconds*1000)

				experienceList.push(
					<div onClick={() => this.handleExp1Click(index)} className={styles.experience}>
						<div className={styles.item}>
							<p className={(this.state.index==i && this.state.show==true)? styles.rotate : styles.normal}>
								&#x3e;
							</p>
							<p className={styles.company}>
								{company}, {title} - ({months[start_date.getMonth()]} {start_date.getFullYear()} - {months[end_date.getMonth()]} {end_date.getFullYear()})
							</p>
						</div>
						
						<div
						style={{display: this.state.index==i ? 'block' : 'none' }}
							className={
								this.state.show
									? styles.fadeIn_experience
									: styles.fadeOut_experience
							}
						>							
							<ul>
							{bullets}
							</ul>  
						</div>
					</div>
				);
			}
			if(experienceList.length == 0){
				experienceList.push(
					<p>No Experience</p>
				)
			}
			return experienceList;
		} catch (err) {
			console.log(err)
			console.log("Error: database fields don't match");
			if(experienceList.length == 0){
				experienceList.push(
					<p>No Experience</p>
				)
			}
			return experienceList;
		}
	}

	// This function is depracated
	displayAccomplishments() {
		const { experiences } = this.state;
		var accomplishmentList = [];
		let accomplishments;
		var i;
		for (i = 0; i < experiences.length; i++) {
			let bullets = [];
			try {
				accomplishments = experiences[i].accomplishments;
				var res = accomplishments.split("*");
				
				var x;
				for(x =0;x<res.length;x++){
					bullets.push(<li>{res[x]}</li>)
				}
				
				
			} catch (err) {
				return;
			}
			
				accomplishmentList.push(
					<div
					style={{display: this.state.index==i ? 'block' : 'none' }}
						className={
							this.state.show
								? styles.fadeIn_experience
								: styles.fadeOut_experience
						}
					>

						<p>ACCOMPLISHMENTS</p>
						
						<ul>
						{bullets}
						</ul>  
					</div>
				);
			
		}

		return accomplishmentList;
	}

	handleExp1Click = (i) => {

		if (i === this.state.index) {
			
			this.setState((state) => {
				return {
					show: !this.state.show,
				};
			});
		} else if (this.state.show == false) {
			
			this.setState((state) => {
				return {
					index: i,
					show: !this.state.show,
				};
			});
		} else {
			
			this.setState((state) => {
				
				return {
					index: i,
				};
			});
		}
	};

	displayEducation() {
		var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
		const { education } = this.state;
		var educationList = [];
		var i;
		try {
			for (i = 0; i < education.length; i++) {
				let institute;
				let degree;
				let courseOfStudy;
				let end;
				let start;
				let degreeCourse;
				try {
					institute = education[i].institute;
					degree = education[i].degree;
					courseOfStudy = education[i].courseOfStudy;
					end = education[i].end;
					start = education[i].start;
					degreeCourse = (degree || courseOfStudy) || ""
				} catch (err) {
					continue;
				}

				let duration = "";
					let educationArray = [];
					if(institute){
						educationArray.push(institute);
					}
					if(degreeCourse){
						educationArray.push(degreeCourse);
					}
					if(start != "" && start != undefined && end != "" && end != undefined){

						var start_date = new Date(start.seconds*1000)
						var end_date = new Date(end.seconds*1000)
						duration =`- (${months[start_date.getMonth()]} ${start_date.getFullYear()} - ${months[end_date.getMonth()]} ${end_date.getFullYear()})`;
					}
					educationList.push(
						<div class="block">
							<p>
								{`${educationArray.join(", ")} ${duration}`}
							</p>
						</div>
					);
			}
			return educationList;
		} catch (err) {
			console.log("Error: database fields don't match");
		}
	}

	displayMentors() {
		const { mentors } = this.state;
		var mentorsList = [];
		var i;

		try {
			for (i = 0; i < 1; i++) {// Change to mentors.length for full list of mentors
				let name;
				let title;
				let content;
				let mentorPic;

				
				try {
					name = mentors[i].name;
					title = mentors[i].title;
					content = mentors[i].content;
					mentorPic=this.state.mentorUrl[i];
				} catch (err) {
					continue;
				}

				
				mentorsList.push(
					<td>
						<div className={styles.mentor}>
							<p>"{content}"</p>
							<div className={styles.mentorContainer}>
								<div className={styles.mentor_img}>
									<img className={styles.mentorProfile} src={mentorPic || add_acc_logo} />
								</div>
								<div className={styles.text_mentor}>
									<h4>{name},</h4>
									<h5>{title}</h5>
								</div>
							</div>
							<br></br>
							<br></br>
						</div>
					</td>
				);
			}
			return mentorsList;
		} catch (err) {
			console.log("Error: database fields don't match");
		}
	}

	async UrlExists(url)
	{
		var http = new XMLHttpRequest();
		http.open('GET', "https://cors-escape.herokuapp.com/" + url, false);
		http.withCredentials = true
		try{
			http.send();
			console.log(http.status)
			this.setState({
				videoExists: http.status!=404,
				checked:true
			})
		}
		catch{
			console.log("Net Err")
		}
		

		console.log(this.state.videoExists)
	}

	displayTechnical() {
		const { skills } = this.state;
		let skillsList=[]
		console.log("skils",skills)
		if(skills == undefined){
			skillsList.push(
				<div className={styles.skill}>No skills</div>
				);	
		}
		else{
			for (let i=0; i<skills.length;i++){
				const skill=skills[i];
				skillsList.push(
				<div className={styles.skill}>{skill}</div>
				);	
	
			}
		}
		
		//let {moodleCandidates}=this.context
		//var canIndex=moodleCandidates.indexOf()
		// if(this.state.title=='Cybersecurity'){
		// 	for (let i = 0; i < 5; i++) {
		// 		var cyberRNG=Math.floor(Math.random()*11)
		// 		const skill = cyberSkills[cyberRNG];
		// 		skillsList.push(
		// 		<div className={styles.skill}>{skill}</div>
		// 		);	
		// 	}		
		// }
		// else{
		// 	for (let i = 0; i < fsSkills.length; i++) {
		// 		const skill = fsSkills[i];
		// 		skillsList.push(
		// 		<div className={styles.skill}>{skill}</div>
		// 		);	
		// 	}		
		// }
	
		
		// for (i = 0; i < technicalSkills.length; i++) {
		// 	const skill = technicalSkills[i];
		// 	skillsList.push(
		// 	<div className={styles.skill}>{skill}</div>
		// 	);
		// 	}
		return skillsList;
	}


	displayLanguages() {
		const { languageSkills } = this.state;

		var skillsList = [];
	
		var i;
		for (i = 0; i < languageSkills.length; i++) {
			const skill = languageSkills[i];
			skillsList.push(
			<div className={styles.skill}>{skill}</div>
			);
			}
		return skillsList;
	}

	handleDataLoad(){
		var storage = firebase.storage();
		
		const mentorInfo =this.props.location.state.mentors;
		let i =0;
		for(i=0;i<mentorInfo.length;i++){
			let name = mentorInfo[i].profile;
			storage.ref('mentorPics').child(name).getDownloadURL().then(url => {
				this.setState(prevState => ({
					mentorUrl: [...prevState.mentorUrl, url]
				  }))
			})

		}


		if (typeof this.props.location.state !== 'undefined') {
			this.setState({
				java: this.props.location.state.java,
				id: this.props.location.state.id,
				name: this.props.location.state.name,
				source: this.props.location.state.source,
				title: this.props.location.state.title,
				remote: this.props.location.state.remote,
				presentation: this.props.location.state.presentation,
				react: this.props.location.state.react,
				vue: this.props.location.state.vue,
				angular: this.props.location.state.angular,
				education: this.props.location.state.education,
				technicalSkills: this.props.location.state.technicalSkills,
				languageSkills: this.props.location.state.languageSkills,
				experiences: this.props.location.state.experiences,
				mentors: this.props.location.state.mentors,
				favoriteClass: this.props.location.state.favoriteClass,
				profileUrl: this.props.location.state.profileUrl,
				grades:this.props.location.state.grades,
				skills:this.props.location.state.skills,
				checked:false
			});
				//console.log(this.state.favoriteClass)

		} 
		else {
			window.location.href = '/View_Candidates';
		}

		//console.log(this.state.favoriteClass)
	}

	componentDidMount() {
		console.log("mounted")
		this.handleDataLoad()
	}

	handleScroll(event) {
		const target = event.target;
		const value = target.value;

		const x = document.getElementById('content1');
		const y = document.getElementById('content2');
		const z = document.getElementById('mentorContent');

		if (value == 1) {
			ReactDOM.findDOMNode(x).scrollLeft += -450;
		} else if (value == 2) {
			ReactDOM.findDOMNode(x).scrollLeft += 450;
		} else if (value == 3) {
			ReactDOM.findDOMNode(y).scrollLeft += -450;
		} else if (value == 4) {
			ReactDOM.findDOMNode(y).scrollLeft += 450;
		} else if (value == 5) {
			ReactDOM.findDOMNode(z).scrollLeft += -500;
		} else if (value == 6) {
			ReactDOM.findDOMNode(z).scrollLeft += 500;
		}
	}

	handleFavoriteClick() {
		const context = this.context;
		const db = firebase.firestore();
		const userRef = db.collection('corporate').doc(context.userID);
		if (this.state.favoriteClass === 'fa fa-star favorite gray move-again') {
			this.setState((prevState) => {
				return {
					favoriteClass: 'fa fa-star favorite gold move-again',
				};
			});

			context.addSavedCand(this.state.id);

			userRef.update({
				savedCandidates: firebase.firestore.FieldValue.arrayUnion(
					this.state.id
				), //adds to savedCandidates array in Firebase
			});
		}
		if (this.state.favoriteClass === 'fa fa-star favorite gold move-again') {
			this.setState((prevState) => {
				return {
					favoriteClass: 'fa fa-star favorite gray move-again',
				};
			});

			context.removeSavedCand(this.state.id);

			userRef.update({
				savedCandidates: firebase.firestore.FieldValue.arrayRemove(
					this.state.id
				), //removes from savedCandidates array in Firebase
			});
		}
	}

	tooltipIsShown(shown) {
		if (shown === true) {
			this.setState((prevState) => {
				return {
					tooltip: 'tooltipvisible',
				};
			});
		}
		if (shown === false) {
			this.setState((prevState) => {
				return {
					tooltip: 'tooltiphidden',
				};
			});
		}
	}

	handleFavoriteEnter() {
		console.log('entered');
		this.setState({
			tooltip: 'tooltipvisible',
		});
	}

	handleFavoriteLeave() {
		console.log('left');
		this.setState({
			tooltip: 'tooltiphidden',
		});
	}

	handleDisplayVideo() {
		
		this.setState({
			showVideo: !this.state.showVideo,
			showPresentation: !this.state.showPresentation,
		});
	}
	
	render() {
		!this.state.checked&&this.UrlExists("https://firebasestorage.googleapis.com/v0/b/minos-labs-57c35.appspot.com/o/candidateVideos%2F"+this.state.name+".mp4?alt=media&token=e397266c-c48a-46e2-b6c6-5012cf43efd0")
		console.log("Rendering")
		console.log(this.state.videoExists)
		//User data
		let { userID, logoutUser, setUser } = this.context;
		return (
			<React.Fragment>
				{/*} <section className="top_image">
                    {/* top image displayed here 
                    </section> */}
				<section className="hero-university2"></section>
				<section className="candidate_process">
					<section className="col-container">
						<Dashboard />
						<div className="right">
            				<div class="topBar">
								<div class="pageName">
									<h1>Candidate Profile</h1>
								</div>
							</div>


							<div className={styles.profileContainer}>
								<div className={styles.blockHeader}>
								</div>
								<div className={styles.profileTop}>
									<div className={styles.profileImageContainer}>
										<img
											className={styles.profileImage}
											src={this.state.profileUrl}
										/>
									</div>
									<div className={styles.profileInfo}>
										<h1>{this.state.name}</h1>
										<p>{this.state.title}</p>
									</div>
									<div className={styles.profileActions}>
									<Link to="/Hire_Candidates_Now">
									<button className={styles.hiringButton}>Submit Hiring Request</button>
									</Link>
										
										<i
											className={` ${styles.favorite} ${this.state.favoriteClass} `}
											onClick={this.handleFavoriteClick}
										></i>{' '}
									</div>
								</div>
								<div className = {styles.profileBottom}>
									<div className ={styles.profileResume}>
									<button className={styles.videoButton} onClick={this.handleDisplayVideo} style={{display:this.state.videoExists?'block':'none'}}>View Candidate {this.state.showPresentation? "Video" : "Presentation"}</button>
									<video style={{display: this.state.showVideo ? 'block' : 'none'}} width="600" height="300"  controls >
								<source src={"https://firebasestorage.googleapis.com/v0/b/minos-labs-57c35.appspot.com/o/candidateVideos%2F"+this.state.name+".mp4?alt=media&token=e397266c-c48a-46e2-b6c6-5012cf43efd0"}>
									</source>
								Your browser does not support the video tag.
								</video>
										<CandidateVideo name={this.state.name} title={this.state.title} profile={this.state.profileUrl} education={this.state.education} experience={this.state.experiences} show={this.state.showPresentation}></CandidateVideo>

										<h2>Experience</h2>
										<div className={styles.experience}>
											<div>{this.displayExperiences()}</div>
										</div>
										
										<h2>Education</h2>
										<div className={styles.education}>
											{this.displayEducation()}
										</div>

										{/* <h2>Mentor</h2>
										<div className={styles.mentor}>
											<div>{this.displayMentors()}</div>
										</div> */}




									</div>

									<div className ={styles.profileGrades}>
										<h2>Coursework</h2>
										{this.displayGrades()}
									</div>

									<div className ={styles.profileSkills}>
										<h2>Skills</h2>
										{/* <h4 style={{display: this.state.languageSkills.length==0 ? 'none' : ''}}>Languages</h4>
										<div className={styles.skillBlock}>
											{this.displayLanguages()}
										</div> */}
										{/* <h4>Technical</h4> */}
										<div className={styles.skillBlock}>
											{this.displayTechnical()}
										</div>
										
									</div>

								</div>

















							</div>




						</div>
						{/*
						<div className={styles.right}>
							<div className={styles.container1}>
								<div className={styles.row}>
									<div className={styles.image}>
										<img
											className={styles.profilepic}
											src={this.state.profileUrl}
										/>
									</div>
									<div className={styles.text}>
										<h1>{this.state.name}</h1>
										<p>{this.state.title}</p>
									</div>
									<button className={styles.videoButton} onClick={this.handleDisplayVideo}>View candidate video</button>
									<video style={{display: this.state.showVideo ? 'block' : 'none'}} width="480" height="320" controls>
								<source src={`/candidate_videos/${this.state.name}.mp4`} type="video/mp4">
									</source>
								Your browser does not support the video tag.
								</video>
									
								
									<h2>Experience</h2>
									<div className={styles.experience}>
										<div>{this.displayExperiences()}</div>
									</div>
									{this.displayAccomplishments()}
								</div>
								<div className={styles.row}>
									<h2 style={{ marginTop: '4px' }}>Mentor</h2>
									<div
										style={{ marginTop: '-28px' }}
										className={styles.slideShow2}
									>
										<button
											value="5"
											onClick={this.handleScroll}
											style={{ marginLeft: '-30px' }}
										>
											&#9664;
										</button>
										<div className={styles.mentorContent} id="mentorContent">
											<table>
												<tbody>
													<tr>{this.displayMentors()}</tr>
												</tbody>
											</table>
										</div>
										<button
											value="6"
											onClick={this.handleScroll}
											style={{ marginRight: '-16.3px' }}
										>
											&#9654;
										</button>
									</div>
								</div>
								<div className={styles.row}>
									<h2>Education</h2>
									<div className={styles.education}>
										{this.displayEducation()}
									</div>
								</div>
							---
								<div class="wrapper">
									<button
										type="button"
										class="profile_button hvr-sweep"
									>
										Previous Profile
									</button>
								</div>
							----
							</div>
						</div>
						<div className={styles.almost_right}>
							<div className={styles.container1}>
								<div className={styles.row}>
									<div className={styles.saveprofile}>
										<span class={styles[this.state.tooltip]}>
											{this.state.tooltiptext}
										</span>
										<i
											style={{ right: '0px' }}
											class={styles[this.state.favoriteClass]}
											onClick={this.handleFavoriteClick}
											onMouseEnter={() => this.tooltipIsShown(true)}
											onMouseLeave={() => this.tooltipIsShown(false)}
										></i>
									</div>
								</div>
								<br></br>
								<br></br>
								<div className={styles.row}>
									<h2>Progress(4/6 Weeks)</h2>
									<br />
									<div
										style={{ width: java }}
										className={styles.progress_bar_Java}
										data-tip
										data-for="javaText"
									>
										<div className={styles.Java}>{this.state.title == "Cybersecurity" ? "Python" : "Java"}</div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="javaText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Java is a class-based, object-oriented programming
										language that is designed to have as few
										implementation dependencies as possible.
									</ReactTooltip>
									<div className={styles.percent}>{java}</div>
									<br></br>
									<div
										style={{ width: vue }}
										className={styles.progress_bar_Vue}
										data-tip
										data-for="vueText"
									>
										<div className={styles.Vue}>{this.state.title == "Cybersecurity" ? "Penetration Testing" : "Vue"}</div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="vueText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Vue.js is an open-source model–view–viewmodel
										JavaScript framework for building user interfaces
										and single-page applications.
									</ReactTooltip>
									<div className={styles.percent}>{vue}</div>
									<br></br>
									<div
										style={{ width: angular }}
										className={styles.progress_bar_Angular}
										data-tip
										data-for="angularText"
									>
										<div className={styles.Angular}>{this.state.title == "Cybersecurity" ? "Security Protocol" : "Angular"}</div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="angularText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Angular is a TypeScript-based open-source web
										application framework led by the Angular Team at
										Google and by a community of individuals and
										corporations.
									</ReactTooltip>
									<div className={styles.percent}>{angular}</div>
									<br></br>
									<div
										style={{ width: react }}
										className={styles.progress_bar_React}
										data-tip
										data-for="reactText"
									>
										<div className={styles.React}>{this.state.title == "Cybersecurity" ? "Vulnerability Assessment" : "React"}</div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="reactText"
										place="top"
										effect="solid"
										multiline={true}
									>
										React is an open-source JavaScript library for
										building user interfaces or UI components.
									</ReactTooltip>
									<div className={styles.percent}>{react}</div>
									<br />
									<div
										style={{ width: presentation }}
										className={styles.progress_bar_Presentation}
										data-tip
										data-for="presentationText"
									>
										<div className={styles.Presentation}>Agile/Scrum</div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="presentationText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Implementing and follow agile methodology and maintaining an up to date scrum board to track team progress and issues
									</ReactTooltip>
									<div className={styles.percent}>{presentation}</div>
									<br></br>
									<div
										style={{ width: remote }}
										className={styles.progress_bar_Remote}
										data-tip
										data-for="remoteText"
									>
										<div className={styles.Remote}>Remote Productivity </div>
									</div>
									<ReactTooltip
										className="tooltip"
										id="remoteText"
										place="top"
										effect="solid"
										multiline={true}
									>
										Candidate readiness to perform under remote working conditions
									</ReactTooltip>
									<div className={styles.percent}>{remote}</div>
								</div>
								<br></br>
								<br></br>
								<div className={styles.row}>
									<h2>Skills</h2>
									<h3>LANGUAGES/FRAMEWORKS</h3>
									<div className={styles.slideShow}>
										<button value="1" onClick={this.handleScroll}>
											&#9664;
										</button>
										<div className={styles.content} id="content1">
											<table>
												<tbody>{this.displayLanguages()}</tbody>
											</table>
										</div>
										<button value="2" onClick={this.handleScroll}>
											&#9654;
										</button>
									</div>
									<h3>TECHNICAL</h3>
									<div className={styles.slideShow}>
										<button value="3" onClick={this.handleScroll}>
											&#9664;
										</button>
										<div className={styles.content} id="content2">
											<table>
												<tbody>{this.displayTechnical()}</tbody>
											</table>
										</div>
										<button value="4" onClick={this.handleScroll}>
											&#9654;
										</button>
									</div>
								</div>
								-----
								<div class="wrapper">
									<button
										type="button"
										class="profile_button2 hvr-sweep"
									>
										Next Profile
									</button>
								</div>
								------
							</div>
						</div>
						*/}
					</section>
				</section>
				<span className={styles.clear}></span>
			</React.Fragment>
		);
	}
}

export default Candidate_Profile;